var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import { formatValue } from './formatValue';

export function formatDimension(col) {
    var language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "nb";
    var dimension = col.dimension,
        type = col.type,
        value = col.value;


    var formattedValue = value;

    if (dimension === "ga:date") {
        formattedValue = formatValue(value, "DATE");
    }

    return _extends({}, col, {
        formattedValue: formattedValue
    });
}